import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../components/Typography';
import Link from '../../components/Link';
import COLORS from '../../util/constants/colors';
import './privacyPolicy.scss';

export const PRIVACY_POLICY_URL = 'https://medsender.com/privacy-policy';
export const TERMS_OF_USE_URL = 'https://medsender.com/terms-of-service';

// iosAppSignIn: the login in the Medsender iOS app's sign-in sheet. The consent line is plain text
// there, with no links: a link would take the sign-in window itself to another site (the marketing
// site offers sign-up and loads its own trackers), with no way back but Cancel. The iOS app links
// its policies on its own sign-in screen, opening in Safari. Every other login, Gibraltar's
// included, links them.
const PrivacyPolicy = ({ iosAppSignIn }) => {
  const size = 'xsmall';
  return (
    <div className="privacy-policy">
      <Typography color={COLORS.TEXT_TERTIARY_LITE} variant="text" size="xsmall">
        {iosAppSignIn ? (
          'By using Medsender, you agree to the Medsender Privacy Policy and Terms of Use.'
        ) : (
          <>
            By using Medsender, you agree to the&nbsp;
            <Link inline href={PRIVACY_POLICY_URL} size={size} label="Privacy Policy" />
            &nbsp;and&nbsp;
            <Link inline href={TERMS_OF_USE_URL} size={size} label="Terms of Use" />
          </>
        )}
        <br />
      </Typography>
      <Typography color={COLORS.TEXT_TERTIARY_LITE} variant="text" size="xsmall">
        {`© ${new Date().getFullYear()} Medsender, Inc.`}
      </Typography>
    </div>
  );
};

PrivacyPolicy.propTypes = {
  iosAppSignIn: PropTypes.bool,
};

PrivacyPolicy.defaultProps = {
  iosAppSignIn: false,
};

export default PrivacyPolicy;
